// extracted by mini-css-extract-plugin
export default {"banner":"HistoryBanner_banner__as8fl","circle":"HistoryBanner_circle__wxAh9","arrow":"HistoryBanner_arrow__NVakp"};